import { useCallback } from 'react';
import { noop } from 'lodash';
import { ArrowDropDownIcon } from 'tuui';
import { DropdownButton, DropdownMenu, STYLED_BUTTON_SIZE, StyledButton, withStylesheet } from 'taboola-ultimate-ui';
import { FORM_MODES } from 'config/formModes';
import { useDropdownOptions } from 'hooks';
import { useNavigate } from 'hooks';
import styles from 'modules/campaigns/modules/campaigns-reports/components/GridToolbar/gridToolbar.module.scss';
import {
    DISPLAY_LIBRARY_CREATIVE_CREATOR_ROUTE_PATH,
    NATIVE_LIBRARY_CREATIVE_CREATOR_ROUTE_PATH,
} from 'modules/creative-library/config';
import { ENTITY } from 'modules/creative-library/config';
import { generateCreativeLibraryPath } from 'modules/creative-library/utils/generateCreativeLibraryPath';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

const StyledAddButtonNewShape = withStylesheet(StyledButton, styles, {
    [StyledButton.classNames.main]: ['tbl-styled-btn', 'override-btn-style'],
    [StyledButton.classNames.iconBefore]: 'dropdown-button-icon',
});

const buttonText = (
    <>
        <FormattedMessage id="app.new" defaultMessage="New" />
        <div className={styles['delimiter']} />
    </>
);

const optionsConfigurations = [
    {
        id: 'native-creative',
        value: 'native-creative',
        label: 'Native creative',
        dataMetricColumnName: 'Native creative',
        handler: ({ navigate, accountId }) => {
            navigate(
                generateCreativeLibraryPath(NATIVE_LIBRARY_CREATIVE_CREATOR_ROUTE_PATH, {
                    mode: FORM_MODES.CREATE,
                    entity: ENTITY.NATIVE,
                    accountId,
                })
            );
        },
    },
    {
        id: 'display-creative',
        value: 'display-creative',
        label: 'Display creative',
        dataMetricColumnName: 'Display creative',
        handler: ({ navigate, accountId }) => {
            navigate(
                generateCreativeLibraryPath(DISPLAY_LIBRARY_CREATIVE_CREATOR_ROUTE_PATH, {
                    mode: FORM_MODES.CREATE,
                    entity: ENTITY.DISPLAY,
                    accountId,
                })
            );
        },
    },
];

export const CreateLibraryCreativeButton = () => {
    const options = useDropdownOptions(optionsConfigurations, 'app.gridToolbar');
    const navigate = useNavigate();
    const selectedAccount = useAccount();
    const handleOnChange = useCallback(
        ({ handler = noop }) => {
            handler({ navigate, selectedAccount });
        },
        [selectedAccount, navigate]
    );

    return (
        <div
            data-metrics-event-name={GTM_EVENTS.USABILITY}
            data-metrics-component="Create Library Creative Button"
            data-automation="Create LibraryC Button"
        >
            <DropdownButton
                ButtonComponent={StyledAddButtonNewShape}
                buttonText={buttonText}
                onChange={handleOnChange}
                buttonSize={STYLED_BUTTON_SIZE.MEDIUM}
                options={options}
                shouldStretchedByContent
                strechedMenuPosition={DropdownMenu.MENU_POSITION.RIGHT}
                buttonIconAfter={<ArrowDropDownIcon style={{ fontSize: 'x-large' }} />}
                dropdownStyles={{
                    menu: {
                        borderRadius: styles.dropdownBorderRadius,
                        border: styles.dropdownBorder,
                        boxShadow: styles.dropdownBoxShadow,
                    },
                }}
            />
        </div>
    );
};
